<template>
    <span :title="fullText">{{ displayText }}</span>
</template>

<script>
export default {
    name: 'TextEllipsis',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        maxLength: {
            type: Number,
            default: 40,
        },
        fallback: {
            type: String,
            default: '-',
        },
    },
    computed: {
        fullText() {
            if (this.value === null || this.value === undefined || this.value === '') {
                return this.fallback
            }

            return String(this.value)
        },
        displayText() {
            const text = this.fullText
            if (text.length <= this.maxLength) {
                return text
            }

            return text.slice(0, this.maxLength) + '...'
        },
    },
}
</script>
